import Vue from "vue";
import Vuex from "vuex";

import user from "./modules/user";
import common from "./modules/common";
import setting from "./modules/setting";
import modal from "./modules/modal";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";
export default new Vuex.Store({
  strict: debug,
  modules: {
    user,
    common,
    setting,
    modal
  }
});

// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
